module.exports = __webpack_public_path__ + "media/images/icons/outlined/linkedin-84560c03affc59ef9fd2a3a8d825e9e2.svg";